import React, { useRef } from 'react';
import Menu from '~/components/menu';
import useComponentVisible from '~/hooks/useComponentVisible';
import { useAppSidebar } from '../provider';
const ProjectsWorkspaceActionsMenu = ({ render }) => {
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible();
    const targetRef = useRef(null);
    const { isArchivedVisible, setIsArchivedVisible } = useAppSidebar();
    if (!render) {
        return null;
    }
    const onMenuItemClick = () => {
        setIsArchivedVisible(!isArchivedVisible);
    };
    const onMenuClicked = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setIsComponentVisible(!isComponentVisible);
    };
    return (React.createElement("div", { className: "action-menu", ref: targetRef },
        React.createElement("button", { onClick: (e) => onMenuClicked(e) },
            React.createElement("i", { className: "far fa-ellipsis-v" })),
        React.createElement(Menu, { ref: ref, targetRef: targetRef.current, showMenu: isComponentVisible, setShowMenu: setIsComponentVisible, onMenuItemClick: onMenuItemClick, menuItems: [{ name: `${isArchivedVisible ? 'Hide' : 'Show'} archived` }] })));
};
export default ProjectsWorkspaceActionsMenu;
